import React from 'react';
import { User } from '../lib/types';
import { getSubscriptionInfo } from '../lib/auth';
import PricingSection from './PricingSection';

interface SubscriptionPanelProps {
  user: User;
}

const SubscriptionPanel: React.FC<SubscriptionPanelProps> = ({ user }) => {
  const subscriptionInfo = user ? getSubscriptionInfo(user.id) : null;

  return (
    <div>
      <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Votre abonnement actuel</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <p className="text-gray-600 mb-2">Statut</p>
            <p className={`font-semibold ${subscriptionInfo?.status === 'Actif' ? 'text-green-600' : 'text-red-600'}`}>
              {subscriptionInfo?.status}
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <p className="text-gray-600 mb-2">Crédits restants</p>
            <p className="font-semibold text-indigo-600">
              {subscriptionInfo?.remainingCredits === 'Illimité' 
                ? 'Illimité' 
                : subscriptionInfo?.remainingCredits}
            </p>
          </div>
        </div>
      </div>

      <PricingSection />
    </div>
  );
};

export default SubscriptionPanel;